import clsx from 'clsx'
import type { ReactNode } from 'react'

import { Chip, type TChipProps } from '@/src/elements/chip'
import { ICON } from '@/src/general/enums/icons'

import type { TMediumCommunityApi } from '../../api/communityApi.types'

type TCommunityMembersChipProps = Pick<TMediumCommunityApi, 'nbMembers'> &
  Pick<TChipProps, 'colors' | 'fontWeight' | 'variant'> & {
    className?: string
    transparent?: boolean
  }

export const CommunityMembersChip = ({
  nbMembers,
  className,
  colors = 'default',
  fontWeight = 'normal',
  transparent = true,
  variant = 'flat',
}: TCommunityMembersChipProps): ReactNode => (
  <Chip
    text={nbMembers.toString()}
    iconName={ICON.USERS}
    fontWeight={fontWeight}
    colors={colors}
    variant={variant}
    dataSet={transparent ? { 'visual-test': 'transparent' } : undefined}
    className={clsx(transparent && 'bg-transparent', className)}
  />
)
